module.exports = __webpack_public_path__ + "media/components/assets/images/sseobolgga/image8_2_sub1-f515e34ebd92265ebf0eb3c939c99f3b.png";